module.exports = __webpack_public_path__ + "static/media/SolucionesTecnologicas.6780ff22.pdf";